/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, colors } from '@material-ui/core';
import configBase from '../../../../../../configBase';

import Collapse from '@material-ui/core/Collapse';

import { 
  DashboardOutlined as DashboardOutlinedIcon,
  Assignment as AssignmentIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  PlaylistAdd as PlaylistAddIcon,
  ChevronRight as ChevronRightIcon,
  ChevronLeft as ChevronLeftIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  PostAdd as PostAddIcon,
  BusinessCenter as BusinessCenterIcon,
  LocalAtm as LocalAtmIcon,
} from '@material-ui/icons';


let show_geralpf = false;
let show_novaspf = false;
let show_indeferidaspf = false;
let show_pendentespf = false;
let show_emaverbacaopf = false;
let show_emanalisepf = false;
let show_canceladaspf = false;
let show_implantadaspf = false;
let show_incluirpropostapf = false;
let show_perfil = false;
let show_linkvendedor = false;
let show_usuarios = false;
let show_corretoras = false;
let show_vendedores = false;
let show_listadependentes = false;
let show_funcEmpresa = false;
let show_planos = false;
let show_faturas = false;
// PJ
let show_incluirpropostapj = false;
let show_geralpj = false;
let show_indeferidaspj = false;
let show_pendentespj = false;
let show_emanalisepj = false;
let show_canceladaspj = false;
let show_implantadaspj = false;


let interval = setInterval(function() {
  if (localStorage.getItem('planos_y') !== null) {
    showMenu(localStorage.getItem('planos_y'));
    clearInterval(interval);
  }
}, 100);

function showMenu(userType) {
  /* Regras para exibir menu de acordo com o perfil do usuário */

  if (userType === 'SALESMAN') {
    show_geralpf = true;
    show_novaspf = true;
    show_indeferidaspf = true;
    show_pendentespf = true;
    show_emaverbacaopf = true;
    show_emanalisepf = true;
    show_canceladaspf = true;
    show_implantadaspf = true;

    show_incluirpropostapf = true;
    show_perfil = true;
    show_linkvendedor = true;
    show_incluirpropostapj = true;
    show_indeferidaspj = true;
    show_pendentespj = true;
    show_emanalisepj = true;
    show_canceladaspj = true;
    show_implantadaspj = true;
    show_geralpj = true;

    if (configBase.moduloDependentes === true)
      show_listadependentes = true;

    if (configBase.moduloFuncEmpresa === true)
      show_funcEmpresa = true;
  }
  else if (userType === 'BROKER'|| userType === 'BACKOFFICE') {
    show_geralpf = true;
    show_novaspf = true;
    show_indeferidaspf = true;
    show_pendentespf = true;
    show_emaverbacaopf = true;
    show_emanalisepf = true;
    show_canceladaspf = true;
    show_implantadaspf = true;
    show_indeferidaspj = true;
    show_pendentespj = true;
    show_emanalisepj = true;
    show_canceladaspj = true;
    show_implantadaspj = true;
    show_geralpj = true;

    if (configBase.moduloFuncEmpresa === true)
      show_funcEmpresa = true;
  }
  else if (userType === 'REGISTER') {
    show_geralpf = true;
    show_emaverbacaopf = true;
    show_emanalisepf = true;
    show_implantadaspf = true;
    show_canceladaspf = true;
    show_indeferidaspf = true;
    show_indeferidaspj = true;
    show_emanalisepj = true;
    show_canceladaspj = true;
    show_implantadaspj = true;
    show_geralpj = true;

    if (configBase.moduloDependentes === true)
      show_listadependentes = true;

    if (configBase.moduloFuncEmpresa === true)
      show_funcEmpresa = true;
  }
  else if (userType === 'AFTER SALES') {
    show_geralpf = true;
    show_emaverbacaopf = true;
    show_implantadaspf = true;
    show_emanalisepf = true;
    show_canceladaspf = true;
    show_indeferidaspf = true;
    show_indeferidaspj = true;
    show_emanalisepj = true;
    show_canceladaspj = true;
    show_implantadaspj = true;
    show_geralpj = true;

    if (configBase.moduloFuncEmpresa === true)
      show_funcEmpresa = true;
  }
  else if (userType === 'ADMIN') {
    show_geralpf = true;
    show_emanalisepf = true;
    show_implantadaspf = true;
    show_canceladaspf = true;
    show_indeferidaspf = true;
    show_emaverbacaopf = true;
    show_indeferidaspj = true;
    show_emanalisepj = true;
    show_canceladaspj = true;
    show_implantadaspj = true;
    show_geralpj = true;
    show_planos = true;

    if (configBase.moduloFuncEmpresa === true)
      show_funcEmpresa = true;

    show_usuarios = true;
    show_corretoras = true;
    show_vendedores = true;
    show_faturas = true;
  }
}



const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  buttonSubMenu: {
    color: '#a7a5a5',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: configBase.corSecundaria,
    backgroundColor: configBase.corPrincipal,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: configBase.corSecundaria
    },
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { className, history, ...rest } = props;

  const classes = useStyles();

  const [openMenuPropostas, setOpenMenuPropostas] = React.useState(false);
  const handleClickMenuPropostas = () => {
    setOpenMenuPropostas(!openMenuPropostas);
  };

  const [openMenuPerfil, setOpenMenuPerfil] = React.useState(false);
  const handleClickMenuPerfil = () => {
    setOpenMenuPerfil(!openMenuPerfil);
  };

  const [openMenuUsuario, setOpenMenuUsuario] = React.useState(false);
  const handleClickMenuUsuario = () => {
    setOpenMenuUsuario(!openMenuUsuario);
  };

  const [openMenuPropostasPJ, setOpenMenuPropostasPJ] = React.useState(false);
  const handleClickMenuPropostasPJ = () => {
    setOpenMenuPropostasPJ(!openMenuPropostasPJ);
  };
  


  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >

      <ListItem
        className={classes.item}
        disableGutters
        key="Dashboard"
        selected={`${process.env.PUBLIC_URL}/dashboard` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/dashboard`}
        >
          <div className={classes.icon}> <DashboardOutlinedIcon /></div>
          Dashboard
        </Button>
      </ListItem>

      {
        show_incluirpropostapf === true ? (
      <ListItem
        className={classes.item}
        disableGutters
        key="Incluir Proposta"
        selected={`${process.env.PUBLIC_URL}/incluirpropostapf` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/incluirpropostapf`}
        >
          <div className={classes.icon}> <PlaylistAddIcon /></div>
          Incluir Proposta
        </Button>
      </ListItem>
        ) : ('')
      }

      {
        show_incluirpropostapj === true ? (
      <ListItem
        className={classes.item}
        disableGutters
        key="Incluir Proposta PJ"
        selected={`${process.env.PUBLIC_URL}/incluirpropostapj` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/incluirpropostapj`}
        >
          <div className={classes.icon}> <PostAddIcon /></div>
          Incluir Proposta PJ
        </Button>
      </ListItem>
        ) : ('')
      }

      <ListItem
        button
        className={classes.item}
        disableGutters
        key="Propostas"
        onClick={handleClickMenuPropostas}
      >
        <Button
          className={classes.button}
        >
          <div className={classes.icon}> <AssignmentIcon /></div>
            Propostas
          <span style={{right: 8, position: 'absolute'}}>
            {openMenuPropostas ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon  fontSize="small" />}
            </span>
        </Button>
      </ListItem>

      <Collapse in={openMenuPropostas} timeout="auto" unmountOnExit>
        {
          show_geralpf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key="Geral"
            selected={`${process.env.PUBLIC_URL}/geralpf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/geralpf`}
            >
              <span style={{marginLeft: 32}}>Geral</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }
        
        {
          show_novaspf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinNova}
            selected={`${process.env.PUBLIC_URL}/novaspf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/novaspf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinNova}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_indeferidaspf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinIndeferida}
            selected={`${process.env.PUBLIC_URL}/indeferidaspf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/indeferidaspf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinIndeferida}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_pendentespf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinPendente}
            selected={`${process.env.PUBLIC_URL}/pendentespf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/pendentespf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinPendente}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_emaverbacaopf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinEmAverbacao}
            selected={`${process.env.PUBLIC_URL}/emaverbacaopf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/emaverbacaopf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinEmAverbacao}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_emanalisepf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinEmAnalise}
            selected={`${process.env.PUBLIC_URL}/emanalisepf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/emanalisepf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinEmAnalise}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_canceladaspf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinCanceladas}
            selected={`${process.env.PUBLIC_URL}/canceladaspf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/canceladaspf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinCanceladas}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_implantadaspf === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinImplementadas}
            selected={`${process.env.PUBLIC_URL}/implantadaspf` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/implantadaspf`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinImplementadas}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_funcEmpresa === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinFuncEmpresa}
            selected={`${process.env.PUBLIC_URL}/funcempresa` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/funcempresa`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinFuncEmpresa}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }
      </Collapse>

      <ListItem
        button
        className={classes.item}
        disableGutters
        key="Propostas PJ"
        onClick={handleClickMenuPropostasPJ}
      >
        <Button
          className={classes.button}
        >
          <div className={classes.icon}> <BusinessCenterIcon /></div>
            Propostas PJ
          <span style={{right: 8, position: 'absolute'}}>
            {openMenuPropostasPJ ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon  fontSize="small" />}
            </span>
        </Button>
      </ListItem>

      <Collapse in={openMenuPropostasPJ} timeout="auto" unmountOnExit>
        {
          show_geralpj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key="Geral"
            selected={`${process.env.PUBLIC_URL}/geralpj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/geralpj`}
            >
              <span style={{marginLeft: 32}}>Geral PJ</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_indeferidaspj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinIndeferidaPJ}
            selected={`${process.env.PUBLIC_URL}/indeferidaspj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/indeferidaspj`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinIndeferidaPJ}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_pendentespj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinPendentePJ}
            selected={`${process.env.PUBLIC_URL}/pendentespj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/pendentespj`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinPendentePJ}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_emanalisepj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinEmAnalisePJ}
            selected={`${process.env.PUBLIC_URL}/emanalisepj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/emanalisepj`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinEmAnalisePJ}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_canceladaspj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinCanceladasPJ}
            selected={`${process.env.PUBLIC_URL}/canceladaspj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/canceladaspj`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinCanceladasPJ}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }

        {
          show_implantadaspj === true ? (
        <List component="div" disablePadding>
          <ListItem
            className={classes.item}
            disableGutters
            key={configBase.statusMinImplementadasPJ}
            selected={`${process.env.PUBLIC_URL}/implantadaspj` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.buttonSubMenu}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/implantadaspj`}
            >
              <span style={{marginLeft: 32}}>{configBase.statusMinImplementadasPJ}</span>
            </Button>
          </ListItem>
        </List>
          ) : ('')
        }
      </Collapse>


      {
        show_perfil === true ? (
      <div>
        <ListItem
          button
          className={classes.item}
          disableGutters
          key="Perfil"
          onClick={handleClickMenuPerfil}
        >
          <Button
            className={classes.button}
          >
            <div className={classes.icon}> <PersonIcon /></div>
              Perfil
            <span style={{right: 8, position: 'absolute'}}>
              {openMenuPerfil ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon  fontSize="small" />}
            </span>
          </Button>
        </ListItem>

        <Collapse in={openMenuPerfil} timeout="auto" unmountOnExit>
          {
            show_linkvendedor === true ? (
          <List component="div" disablePadding>
            <ListItem
              className={classes.item}
              disableGutters
              key="Link do Vendedor"
              selected={`${process.env.PUBLIC_URL}/linkvendedor` === history.location.pathname}
            >
              <Button
                activeClassName={classes.active}
                className={classes.buttonSubMenu}
                component={CustomRouterLink}
                to={`${process.env.PUBLIC_URL}/linkvendedor`}
              >
                <span style={{marginLeft: 32}}>Link do Vendedor</span>
              </Button>
            </ListItem>
          </List>
            ) : ('')
          }

        </Collapse>
      </div>
        ) : ('')
      }

      {
        show_usuarios === true ? (
      <div>
        <ListItem
          button
          className={classes.item}
          disableGutters
          key="Usuários"
          onClick={handleClickMenuUsuario}
        >
          <Button
            className={classes.button}
          >
            <div className={classes.icon}> <GroupIcon /></div>
              Usuários
            <span style={{right: 8, position: 'absolute'}}>
              {openMenuUsuario ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon  fontSize="small" />}
            </span>
          </Button>
        </ListItem>

        <Collapse in={openMenuUsuario} timeout="auto" unmountOnExit>
        {
            show_corretoras === true ? (
          <List component="div" disablePadding>
            <ListItem
              className={classes.item}
              disableGutters
              key="Corretoras"
              selected={`${process.env.PUBLIC_URL}/corretoras` === history.location.pathname}
            >
              <Button
                activeClassName={classes.active}
                className={classes.buttonSubMenu}
                component={CustomRouterLink}
                to={`${process.env.PUBLIC_URL}/corretoras`}
              >
                <span style={{marginLeft: 32}}>Corretoras</span>
              </Button>
            </ListItem>
          </List>
            ) : ('')
          }

          {
            show_vendedores === true ? (
          <List component="div" disablePadding>
            <ListItem
              className={classes.item}
              disableGutters
              key="Vendedores"
              selected={`${process.env.PUBLIC_URL}/vendedores` === history.location.pathname}
            >
              <Button
                activeClassName={classes.active}
                className={classes.buttonSubMenu}
                component={CustomRouterLink}
                to={`${process.env.PUBLIC_URL}/vendedores`}
              >
                <span style={{marginLeft: 32}}>Vendedores</span>
              </Button>
            </ListItem>
          </List>
            ) : ('')
          }
        </Collapse>
      </div>
        ) : ('')
      }

      {
        show_listadependentes === true ? (
      <ListItem
        className={classes.item}
        disableGutters
        key="Gestão de Dependentes"
        selected={`${process.env.PUBLIC_URL}/listadependentes` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/listadependentes`}
        >
          <div className={classes.icon}> <PlaylistAddIcon /></div>
          Gestão de Dependentes
        </Button>
      </ListItem>
        ) : ('')
      }

       {
        show_planos === true ? (
      <ListItem
        className={classes.item}
        disableGutters
        key="Cupom de Desconto"
        selected={`${process.env.PUBLIC_URL}/planos` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/planos`}
        >
         <div className={classes.icon}> <AssignmentIcon /></div>
            Planos
        </Button>
      </ListItem>
        ) : ('')
      }

      {
        show_faturas === true ? (
          <ListItem
            className={classes.item}
            disableGutters
            key="Faturas"
            selected={`${process.env.PUBLIC_URL}/faturas` === history.location.pathname}
          >
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={`${process.env.PUBLIC_URL}/faturas`}
            >
              <div className={classes.icon}> <LocalAtmIcon /></div>
              Faturas
            </Button>
          </ListItem>
        ) : ('')
      }

      <ListItem
        className={classes.item}
        disableGutters
        key="Logout"
        selected={`${process.env.PUBLIC_URL}/sair` === history.location.pathname}
      >
        <Button
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={`${process.env.PUBLIC_URL}/sair`}
        >
          <div className={classes.icon}> <PowerSettingsNewIcon /></div>
          Logout
        </Button>
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  //pages: PropTypes.array.isRequired,
  history: PropTypes.object,
};

export default SidebarNav;
